import React from 'react';
import UnitList from '../screens/UnitList';

const UnitChooser = ({navigation}) => (
  <UnitList navigation={navigation}  hasDrawer={true} />
);

export default UnitChooser;
